module.exports = __webpack_public_path__ + "img/ic-whats-app-square.fbe264ee.svg";